export default class Program {

  uuid: string
  name: string
  contacted: number
  uncontacted: number
  total: number

}